import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";
import BootstrapTable from "react-bootstrap-table-next";
import {
  Row,
  Col,
  Card,
  CardBody,
  Button,
  FormGroup,
  Label,
  Container,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Spinner,
} from "reactstrap";
import classnames from "classnames";
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {
  AvField,
  AvForm,
  AvRadio,
  AvRadioGroup,
} from "availity-reactstrap-validation";
import preloader from "../../helpers/preloader";
import showNotification from "../../helpers/show_notification";
import { postSubmitForm } from "../../helpers/forms_helper";

const ItemsMapToAll = (props) => {
  const [activeTab, setActiveTab] = useState("map");
  const refContainer = useRef(null)
  const [selectedItem, setSelectedItem] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showConfig, setShowConfig] = useState(false);
  const [branches, setBranches] = useState([]);

  useEffect(()=>{
    loadAllItems()
  },[])


  const columns = [
    {
        dataField: "_id",
        hidden: true,
    },
    {
        dataField: "_id",
        text: "#",
        formatter: (cell, row, rowIndex) => {
            return rowIndex + 1
        },
        headerStyle: (colum, colIndex) => {
            return { width: "5%" };
          },
    },
    {
      dataField: "name",
      text: "Branch Name",
      sort: true,
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (cell,row) => {        
        return (
        <div>
          <i
            className={`bx ${
              row.is_mapped 
                ? "bx-check-circle text-success"
                : "bx-x-circle text-danger"
            } font-size-16 align-middle`}
          ></i>
          {/* <span className="ms-2">{cell}</span> */}
        </div>
      )},
    },
  ];


  const handleItemSelect = (selected) => {
    setSelectedItem(selected);
  };

  const [allItems, setAllItems] = useState([]);
  const [catalogLoading, setCatalogLoading] = useState(true);
  const loadAllItems = async () => {
    try {
      setCatalogLoading(true);
      let url = process.env.REACT_APP_BASEURL + "items/getall";
    let response = await postSubmitForm(url, { catalog_only: true });
    if (response.status === 1) {
      let filtered = response.data?.filter((d)=>d.is_active) || [];
      setAllItems(filtered);
    } else {
      showNotification(response.message, "error")
    }
    } catch (error) {
      console.log(error);
      
    } finally {
      setCatalogLoading(false);
    }
  };

  const handleMapping = async (type) => {
    try {
      preloader(true);
      setShowConfig(true)
      let endpoint = type === "mapping" ? "branchitems/get_unmapped" : "branchitems/get_mapped";
      let url = process.env.REACT_APP_BASEURL + endpoint;
      let response = await postSubmitForm(url, {item_id: selectedItem.value});
      if (response.status === 1) {
        const updated = response.data.map(item => ({ ...item, is_mapped: true })).sort((a, b) => a.name.localeCompare(b.name));;
        // refContainer.current.reset();
        setBranches(updated);
      }
    } catch (error) {
      console.log(error);
    } finally {
      preloader(false);
    }
  };

  const handleSubmit = async (type,e,v) => {
    try {
      setIsSubmitting(true);
      let endpoint = type === "mapping" ? "branchitems/map_branches" : "branchitems/unmap_branches";
      let payload = {
        item_id: selectedItem.value,
        // branch_ids: branches.map(branch => ({branch_id: branch._id})),
        branch_ids: branches.filter(branch=>branch.is_mapped).map(branch => branch._id),
      };
      if(type === "mapping") {
        Object.assign(payload,{
          direct_po : v.direct_po === "Yes" ? true : false,
          is_po_allowed: v.is_po_allowed === "Yes" ? true : false, 
          threshold: +v.threshold, 
          max_order_limit: +v.max_order_limit, 
          max_order_limit_weekly: +v.max_order_limit_weekly
        })
      };
  
      let url = process.env.REACT_APP_BASEURL + endpoint;
      let response = await postSubmitForm(url, payload);
      if (response.status === 1) {
        showNotification(response.message, "Success");
        if(type==="mapping"){
          refContainer.current.reset();
        }
        setBranches([])
        setSelectedItem(null);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setSelectedItem(null);
      setBranches([]);
    }
  };

  const selectRow = {
    mode: 'checkbox',
    clickToSelect: true,
    selected: branches.filter(item => item.is_mapped).map(item => item._id),
    onSelect: (row, isSelect) => {
        setBranches(prevData => 
          prevData.map(item => 
            item._id === row._id 
              ? { ...item, is_mapped: isSelect }
              : item
          )
        );
      },
    onSelectAll: (isSelect, rows) => {
        setBranches(prevData =>
          prevData.map(item => ({ ...item, is_mapped: isSelect }))
        );
        if (isSelect) {
          return rows.map(row => row._id);
        }
        return [];
      },
  };

  return (
    <React.Fragment>

      
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title={props.t("Item - Branches Mapping/Unmapping")}
            // breadcrumbItem={props.t("Branch Items - Sub Store")}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <Nav tabs className="nav-tabs-custom">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "map" })}
                        onClick={() => toggleTab("map")}
                      >
                        {props.t("Map Items")}
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({
                          active: activeTab === "unmap",
                        })}
                        onClick={() => toggleTab("unmap")}
                      >
                        {props.t("Unmap Items")}
                      </NavLink>
                    </NavItem>
                  </Nav>

                  <TabContent activeTab={activeTab} className="p-3">
                    <TabPane tabId="map">
                        <Row>
                          <Col md={6}>
                            <FormGroup>
                              <Label>{props.t("Select Item to Map")}</Label>
                              <Select
                                options={allItems}
                                value={selectedItem}
                                onChange={handleItemSelect}
                                isLoading={catalogLoading}
                                classNamePrefix="select2-selection"
                              />
                            </FormGroup>
                          </Col>
                          <Col md={6}>
                            <Button
                              color="success"
                              className="mt-4"
                              onClick={()=>handleMapping("mapping")}
                            >
                              <i className="mdi mdi-checkbox-marked-circle"></i>{" "}
                              {props.t("Map To All")}
                            </Button>
                          </Col>
                        </Row>

                        {showConfig && (
                          <>
                            <AvForm
                              onValidSubmit={(e,v)=>handleSubmit("mapping",e,v)}
                              className="mt-4"
                              ref={refContainer}
                            >
                              {selectedItem && (
                                <Row>

                                <Col md={2}>
                                  <AvField
                                    name="max_order_limit"
                                    defaultValue="0"
                                    label={props.t(`Max Order Limit (${selectedItem?.unit_for_max_order})`)}
                                    placeholder={props.t(
                                      "Enter Max Order Limit"
                                    )}
                                    type="number"
                                    validate={{
                                      required: {
                                        value: true,
                                        errorMessage: props.t(
                                          "Max Order Limit cannot be empty."
                                        ),
                                      },
                                      pattern: {
                                        value: "^[0-9]+$",
                                        errorMessage: props.t(
                                          "Only numbers are allowed."
                                        ),
                                      },
                                    }}
                                  />
                                </Col>

                                <Col md={2} hidden={!selectedItem?.is_premium_item}>
                                  <AvField
                                    name="max_order_limit_weekly"
                                    label={props.t(`Weekly Order Limit (${selectedItem?.unit_for_max_order})`)}
                                    defaultValue="0"
                                    placeholder={props.t(
                                      "Enter Weekly Order Limit"
                                    )}
                                    type="number"
                                    validate={{
                                      required: {
                                        value: true,
                                        errorMessage: props.t(
                                          "Weekly Order Limit cannot be empty."
                                        ),
                                      },
                                      pattern: {
                                        value: "^[0-9]+$",
                                        errorMessage: props.t(
                                          "Only numbers are allowed."
                                        ),
                                      },
                                    }}
                                  />
                                </Col>

                                <Col lg={2}>
                                  <AvField
                                    name="threshold"
                                    label={props.t(`Threshold Qty (${selectedItem?.unit_for_max_order})` )}
                                    defaultValue="0"
                                    placeholder={props.t(
                                      "Enter Threshold Quantity"
                                    )}
                                    type="number"
                                    validate={{
                                      required: {
                                        value: true,
                                        errorMessage: props.t(
                                          "Threshold cannot be empty."
                                        ),
                                      },
                                      pattern: {
                                        value: "^[0-9]+$",
                                        errorMessage: props.t(
                                          "Only numbers are allowed."
                                        ),
                                      },
                                    }}
                                  />
                                </Col>

                                <Col lg={2} className="mt-2">
                                  <AvRadioGroup
                                    inline
                                    defaultValue="No"
                                    name="direct_po"
                                    required
                                    errorMessage={props.t("Select an option")}
                                  >
                                    <Label>{props.t("From Supplier ?")}</Label>
                                    <br />
                                    <AvRadio
                                     
                                      label="Yes"
                                      value="Yes"
                                    />
                                    <AvRadio
                                      label="No"
                                      value="No"
                                    />
                                  </AvRadioGroup>
                                </Col>

                                <Col lg={2} className="mt-2">
                                  <AvRadioGroup
                                    inline
                                    name="is_po_allowed"
                                    defaultValue="No"
                                    required
                                    errorMessage={props.t("Select an option")}
                                  >
                                    <Label>{props.t("Po Allowed ?")}</Label>
                                    <br />
                                    <AvRadio
                                      label="Yes"
                                      value="Yes"
                                    />
                                    <AvRadio
                                      label="No"
                                      value="No"
                                    />
                                  </AvRadioGroup>
                                </Col>
                              </Row>
                              ) }
                            <BootstrapTable
                              keyField="_id"
                              data={branches}
                              columns={columns}
                              selectRow={ selectRow }
                              noDataIndication="No data to display."
                              striped
                              hover
                              condensed
                            />

                            <div className="d-flex justify-content-center mt-3">
                              <Button color="primary" type="submit" style={{width: "100px"}} disabled={isSubmitting}>
                                {isSubmitting ? <Spinner size="sm"/> : props.t("Submit")}
                              </Button>
                            </div>
                            </AvForm>

                          </>
                        )}
                    </TabPane>

                    {/* Unmapp  */}
                    <TabPane tabId="unmap">
                    <Row>
                          <Col md={6}>
                            <FormGroup>
                              <Label>{props.t("Select Item to Unmap")}</Label>
                              <Select
                                options={allItems}
                                value={selectedItem}
                                onChange={handleItemSelect}
                                isLoading={catalogLoading}
                                classNamePrefix="select2-selection"
                              />
                            </FormGroup>
                          </Col>
                          <Col md={6}>
                            <Button
                              color="success"
                              className="mt-4"
                              onClick={()=>handleMapping("unmapping")}
                            >
                              <i className="mdi mdi-checkbox-marked-circle"></i>{" "}
                              {props.t("Unmap To All")}
                            </Button>
                          </Col>
                        </Row>

                        {showConfig && (
                          <>
                            <AvForm
                              onValidSubmit={()=>handleSubmit("unmapping")}
                              className="mt-4"
                            >
                            <BootstrapTable
                              keyField="_id"
                              data={branches}
                              columns={columns}
                              selectRow={ selectRow }
                              noDataIndication="No data to display."
                              striped
                              hover
                              condensed
                            />

                            <div className="d-flex justify-content-center mt-3">
                            <Button color="primary" type="submit" style={{width: "100px"}} disabled={isSubmitting}>
                                {isSubmitting ? <Spinner size="sm"/> : props.t("Submit")}
                              </Button>
                            </div>
                            </AvForm>

                          </>
                        )}
                    </TabPane>
                  </TabContent>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(connect(null, {})(withNamespaces()(ItemsMapToAll)));
